<style lang="less" scoped>
  .query-title-div {
    width: 110px !important;
  }
  .lang-width {
    width: 450px !important;
  }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">升级管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">厂商标识</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.manufactorId" clearable>
                <el-option v-for="item in manufactors" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩型号</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pileTypeCode"
               
                  clearable
                 
                  no-data-text="暂无数据"
                @focus="getPileList"
              >
               
                  <el-option v-for="item in pile" :label="item.pileTypeName" :value="item.pileTypeNo" :key="item.pileTypeNo"></el-option>
                
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩编号</div>
            <div class="query-inputs-div flex-1">
          
              <el-input size="small" v-model="queryInfo.pileNo" placeholder="请输入内容" clearable
                @keyup.enter.native="handleSearch()"></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">升级状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.upgradeStatus"
                clearable
              >
                <el-option label="已升级" value="已升级"></el-option>
                <el-option label="未升级" value="未升级"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属用户</div>
            <div class="query-inputs-div flex-1">
             
              <el-input size="small" v-model="queryInfo.custPhone" placeholder="请输入内容" clearable
                @keyup.enter.native="handleSearch()"></el-input>
            </div>
          </div>
        
          <div class="list-query-child-div flex">
            <div class="query-title-div">是否有蓝牙</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.isBluetooth"
                clearable
              >
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">升级方式</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.upgradeMethod"
                clearable
              >
                <el-option label="在线" value="在线"></el-option>
                <el-option label="离线" value="离线"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">当前版本号</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.currentVersionNo"
                clearable
              >
                <el-option v-for="(item,index) in versionNo" :label="item" :value="item" :key="index"></el-option>
                
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class="">
            <button class="common-bg-button" @click="handleSearch()">搜 索</button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
          <!-- <div class="">
            <button class="common-bg-button" @click="toExportList" style="width:80px;margin-top:15px">导出</button>
          </div> -->
        </template>
      </ZD-list-querys>
      <div class="page-action-btns flex" style="margin-bottom:10px;">
        <!-- <button class="common-bg-button" @click="listDetailFun()">详 情</button> -->
        <el-button type="primary" size="small" @click="listEditFun()">编 辑</el-button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections=" (sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config';
import utils from '../../../utils/utils';
export default {
  data() {
    return {
      versionNo:[],
      pile:[],
      manufactors:[],
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      isFirstLoad: true, // 是否首次加载
      value1: true, //未使用
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          // {
          //   id: 'relation',
          //   label: '关联账号',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileCode)
          //     window.open(
          //             this.$router.resolve({ name: pageConfig.relationNum }).href,
          //             '_blank'
          //     )
          //   }
          // }
        ],
      }, // 列操作按钮
      searchTime: [], //系统创建时间
    }
  },
  methods: {
      //查找站点名称 获取数据
    init() {
      if (this.$route.params.stationName) {
        this.queryInfo.stationName = this.$route.params.stationName
      }
      if (this.$route.query.stationNo) {
        this.queryInfo.stationNo = this.$route.query.stationNo
      }
      // 首次加载不调用接口，只获取基础数据
      // this.getListData(this.pagination, true)
      this.getManufactors()
      this.getVersionNo()
    },
    // 检查是否有查询条件
    hasQueryConditions() {
      const { 
        manufactorId, 
        pileTypeCode, 
        pileNo, 
        upgradeStatus, 
        custPhone, 
        isBluetooth, 
        upgradeMethod, 
        currentVersionNo,
        stationName,
        stationNo
      } = this.queryInfo;
      return manufactorId || pileTypeCode || pileNo || upgradeStatus || 
             custPhone || isBluetooth || upgradeMethod || currentVersionNo ||
             stationName || stationNo;
    },
    // 搜索方法
    handleSearch() {
      if (!this.hasQueryConditions()) {
        this.$U.error('请输入查询条件');
        return;
      }
      this.isFirstLoad = false;
      this.getListData(this.pagination, true);
    },

    
    // 获取厂商标识
    getManufactors() {
      let _ = this;
      _.$H.get(_, _.$A.pile.listManufactorId).then((res) => {
       _.manufactors = res.data.data
      });
      
    },


    getPileList(){
    if(this.queryInfo.manufactorId == '' || this.queryInfo.manufactorId == null){
      return  utils.error('请选择厂商');
    }else{
      this.getPile(this.queryInfo.manufactorId);
    }
    },

     // 获取版本号

     getVersionNo(){
      let _ = this;
      _.$H.post(_, _.$A.custVersion.version,{}).then((res) => {
        console.log(res);
       _.versionNo = res.data.data.map((item)=>{
        return item.versionNo
       })
       console.log(_.versionNo);
      });
      
    },



    // 获取充电桩

    getPile(id) {
      let _ = this;
      _.$H.post(_, _.$A.pile.listFeign, {manufactorId:id}).then((res) => {
        console.log(res.data);
        _.pile = res.data.data.map((item) => {
          return {
            pileTypeName: item.pileTypeName,
            pileTypeNo: item.pileTypeNo,
     
          };
        });
       
      });
    },



    // 获取表格数据
    getListData(pagination, reload = false) {
      // 如果是首次加载且没有查询条件，不调用接口
      if (this.isFirstLoad && !this.hasQueryConditions()) {
        return;
      }
      
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.upgradeManager.page, _.queryInfo).then(res => {
      // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    //改功能已删除
    getPileCodeArr(query) {
      let _ = this
      if (query.length >= 4) {
        //this.loading = true;
        var obj = {
          sort: '-pileCode',
          pileCode: query,
        }
        _.$H.post(_, _.$A.pile.findPileCodeList, obj).then((res) => {
          _.pileCodeArr = res.data.data
        })
      } else {
        this.pileCodeArr = []
      }
    },
    // 页面新增方法
    listAddFun() {
      localStorage.removeItem('upgradeDetail')
      this.$S.listAddFun(this, pageConfig.tableEditObj)
    },
    // 页面编辑方法
    // listDetailFun() {
    //     this.$S.listEditFun(this, this.selections, pageConfig.tableDetailObj);
    // },
    //页面编辑方法
    listEditFun() {
      let _ = this
      if (_.selections.length <= 0) {
        utils.error('请选择需要操作的记录');
        return;
    } else if (_.selections.length > 1) {
        utils.error('请选择一条记录进行操作');
        return;
    }else{
      // console.log(_.selections);
      // Cookies.remove('versionDetail')
      localStorage.removeItem('upgradeDetail')
      localStorage.setItem('upgradeDetail', JSON.stringify(_.selections[0]))
      // Cookies.set('versionDetail', JSON.stringify(_.selections[0]))
      window.open(this.$router.resolve({ name: 'upgradeDetail' }).href, '_blank')
    }
      
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0]
        this.queryInfo.dtTo = val[1]
      } else {
        delete this.queryInfo.dtFrom
        delete this.queryInfo.dtTo
      }
    },
    //下载
    toExportList() {
      let _ = this
      // if(_.queryInfo.optType != '02'){
      //     _.$U.error('仅支持公共桩导出');
      //     return;
      // }
      if (_.queryInfo.optType == '' || _.queryInfo.optType == undefined) {
        _.$U.error('请选择充电桩类型')
        return
      }
      _.$U.showLoading(_)
      _.$H.post(_, _.$A.pile.exportPile, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data)
        var downUrl = 'http://ocharge.shzhida.com:6775' + res.data.data.data
        window.open(downUrl, '_blank')
        _.$U.hideLoading(_)
      })
    },
    //重置
    reset() {
      this.pagination.current = 1
      delete this.queryInfo.manufactorId
      delete this.queryInfo.pileTypeCode
      delete this.queryInfo.currentVersionNo 
      delete this.queryInfo.upgradeMethod
      delete this.queryInfo.isBluetooth
      delete this.queryInfo.custPhone
      delete this.queryInfo.upgradeStatus
      delete this.queryInfo.pileNo
      delete this.queryInfo.pileCode
      delete this.queryInfo.optType
      delete this.queryInfo.isRepair
      delete this.queryInfo.userReply
      delete this.queryInfo.dtFrom
      delete this.queryInfo.dtTo
      this.searchTime = []
      this.getListData(this.pagination)
    },
  },
  mounted() {
    this.init()
  },
}
</script>
